import {
  LOGOUT,
  NOTIFICATION_RECEIVED,
  CLEAR_FEED_NOTIFICATIONS,
  MARK_ALL_FEED_READ,
  MARK_FEED_NOTIFICATION_READ,
  REMOVE_FEED_NOTIFICATION,
} from "../ActionTypes";

const initialState = {
  notifications: [],
};

export const notificationFeed = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case NOTIFICATION_RECEIVED: {
      const notification = action.payload;
      if (!notification?.id) {
        newState = state;
        break;
      }

      const existingIndex = state.notifications.findIndex(
        (n) => n.id === notification.id,
      );
      if (existingIndex >= 0) {
        newState = {
          ...state,
          notifications: state.notifications.map((item, index) =>
            index === existingIndex ? { ...item, ...notification } : item,
          ),
        };
        break;
      }

      newState = {
        ...state,
        notifications: [notification, ...state.notifications],
      };
      break;
    }

    case CLEAR_FEED_NOTIFICATIONS:
      newState = { ...state, notifications: [] };
      break;

    case LOGOUT:
      newState = initialState;
      break;

    case MARK_ALL_FEED_READ:
      newState = {
        ...state,
        notifications: state.notifications.map((notification) => ({
          ...notification,
          isRead: true,
          readAt: notification.readAt ?? new Date().toISOString(),
        })),
      };
      break;

    case MARK_FEED_NOTIFICATION_READ: {
      const notificationId = action.payload;
      newState = {
        ...state,
        notifications: state.notifications.map((notification) =>
          notification.id === notificationId
            ? {
                ...notification,
                isRead: true,
                readAt: notification.readAt ?? new Date().toISOString(),
              }
            : notification,
        ),
      };
      break;
    }

    case REMOVE_FEED_NOTIFICATION: {
      const notificationId = action.payload;
      newState = {
        ...state,
        notifications: state.notifications.filter((n) => n.id !== notificationId),
      };
      break;
    }

    default:
      newState = state;
  }

  return newState;
};
